module.exports = __webpack_public_path__ + "img/EATechWord4.96e7725c.png";